export default __webpack_public_path__ + "7723ca0d1a48ad401afaeef5cb7a378a.png";